'use client';

import { SvgBookmarkFill } from '@common/icon';
import { cn } from '@common/utils';
import { useState } from 'react';
import CountUp from 'react-countup';
import { useInView } from 'react-intersection-observer';

interface BookmarkButtonProps {
  bookmarkCount?: number;
  isBookmarked?: boolean;
  onClick?: (isBookmarked: boolean) => void;
}

export const BookmarkButton = ({
  bookmarkCount = 0,
  isBookmarked = false,
  onClick,
}: BookmarkButtonProps) => {
  const [isDisplayed, setIsDisplayed] = useState(false);

  const inView = useInView({
    onChange: (inView) => {
      if (inView) {
        setIsDisplayed(true);
      }
    },
  });

  return (
    <button
      ref={inView.ref}
      className="group h-36 gap-4 rounded-pill border border-Gray-300 px-16 flex-center"
      type="button"
      onClick={(e) => {
        e.preventDefault();
        onClick?.(isBookmarked);
      }}
    >
      <SvgBookmarkFill
        className={cn(
          'size-18 text-Gray-400',
          'duration-75 group-active:scale-75',
          {
            'text-B-500': isBookmarked,
          },
        )}
      />
      {isDisplayed ? (
        <CountUp
          preserveValue
          startOnMount
          className="font-400 text-Gray-700 typo-body4"
          end={bookmarkCount}
        />
      ) : null}
    </button>
  );
};
